import { Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { viewImage } from '../../CommonUtils/viewImage';
import { IoEyeOutline } from 'react-icons/io5';
import { ImagePdfBucket } from '../../CommonUtils/ImagesBase64';
import { FaEye } from 'react-icons/fa';

export default function AfflFfcaPhoto() {
    const userId = sessionStorage.getItem('user_id');
    const acYear = sessionStorage.getItem('ac_year');
    const AfflFfcaPhotoFormik = useFormik({
        initialValues: {
            tmcPhoto1: '',
            tmcPhoto2: '',
            tmcPhoto3: '',
            tmcPhoto4: '',
            tmcPhoto5: '',
            tmcPhoto6: '',
            tmcPhoto7: '',
            tmcPhoto8: '',
            tmcPhoto9: '',
            tmcPhoto10: ''
        },
        enableReinitialize: true,
        onSubmit: async (values) => {
            const updatedValues = { ...values };
            for (let index = 1; index <= 10; index++) {
                const fieldName = `tmcPhoto${index}`; const photoKey = `tmc_photo_${index}`;
                if (values[fieldName]) {
                    updatedValues[fieldName] = values[fieldName];
                } else if (initialFfcaPhoto && initialFfcaPhoto[photoKey]) {
                    updatedValues[fieldName] = initialFfcaPhoto[photoKey];
                }
            }
            let missingPhotos = [];
            for (let index = 1; index <= 10; index++) {
                const fieldName = `tmcPhoto${index}`; const photoKey = `tmc_photo_${index}`; const isPhotoAvailable = FfcaPhoto[photoKey];

                if (!isPhotoAvailable && !values[fieldName]) {
                    missingPhotos.push(index);
                }
            }

            const showMissingPhotoAlert = (index) => {
                return Swal.fire({
                    text: `Please upload photo for FFCA Team Photo ${index} at college.`,
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                });
            };

            const handleSequentialAlerts = async (photosToCheck) => {
                for (let i = 0; i < photosToCheck.length; i++) {
                    const index = photosToCheck[i];
                    await showMissingPhotoAlert(index);
                    if (FfcaPhoto[`tmc_photo_${index}`] || values[`tmcPhoto${index}`]) {
                        continue;
                    } else {
                        break;
                    }
                }
            };
            if (missingPhotos.length > 0) {
                await handleSequentialAlerts(missingPhotos);
            } else {
                Swal.fire({
                    text: 'Are you sure you want to submit?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, submit it!',
                    cancelButtonText: 'No, cancel!',
                    backdrop: false,
                }).then((result) => {
                    if (result.isConfirmed) {
                        const url = `${config.url.API_URL}saveFfcaTeamPhoto`;
                        CommonAxiosPost(url, updatedValues).then((res) => {
                            if (res?.data?.scode === '01') {
                                successAlert2(res?.data?.sdesc);
                                GetFfcaPhotoData();
                            } else {
                                failureAlert(res?.data?.sdesc);
                            }
                        });
                    } else {
                        console.log('Submission canceled');
                    }
                });
            }
        }

    })


    const [initialFfcaPhoto, setInitialFfcaPhoto] = useState(null);
    const [FfcaPhoto, setFfcaPhoto] = useState([]);

    function GetFfcaPhotoData() {
        let url = config.url.API_URL + `getFfcaTeamPhotoReport`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const photoData = res?.data?.FfcaTeamPhotoReport[0];
                setInitialFfcaPhoto(photoData);
                setFfcaPhoto(photoData);
                const photoFields = ['tmcPhoto1', 'tmcPhoto2', 'tmcPhoto3', 'tmcPhoto4', 'tmcPhoto5', 'tmcPhoto6', 'tmcPhoto7', 'tmcPhoto8', 'tmcPhoto9', 'tmcPhoto10'];
                photoFields.forEach((fieldName, index) => {
                    const photoKey = `tmc_photo_${index + 1}`;
                    if (photoData[photoKey]) {
                        AfflFfcaPhotoFormik.setFieldValue(fieldName, photoData[photoKey]);
                    } else {
                        AfflFfcaPhotoFormik.setFieldValue(fieldName, '');
                    }
                });
            } else {
                setFfcaPhoto([]);
            }
        });
    }


    useEffect(() => {
        GetFfcaPhotoData();
    }, [])
    return (
        <>
            <CommonFormHeading heading="FFCA Team Photo at college" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AfflFfcaPhotoFormik}>
                        <bie.Row className="px-2 pt-3 mb-3">
                            <Form onChange={AfflFfcaPhotoFormik.handleChange} onSubmit={AfflFfcaPhotoFormik.handleSubmit} className='affl-form'>
                                <bie.Alert variant='danger' className='affl-alert'>
                                    <p className='mb-0'>Note:FFCA Team is requested to take the Inspection Video .</p>
                                    <p className='mb-0'>In All Photos FFCA Team members should be available(College Building,Class Rooms,Labs)</p>
                                </bie.Alert>
                                <div className="table-responsive">
                                    <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                        <thead>
                                            <tr>
                                                <th>S.No</th>
                                                <th>Discription</th>
                                                <th>Upload </th>
                                            </tr>
                                        </thead>
                                        <tbody >
                                            {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((index) => (
                                                <tr key={index}>
                                                    <td className='cen'>{index}</td>
                                                    <td className='text-left'>FFCA Team Photo {index} at college</td>
                                                    <td>
                                                        <bie.Row className='align-items-center'>
                                                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6} className='mb-2'>
                                                                <input type="file" className="form-control" name={`tmcPhoto${index}`} accept="image/*"
                                                                    onChange={(e) => {
                                                                        let fileVal = `${userId}_${acYear}`;
                                                                        let filename = `${fileVal}tmcPhoto${index}`;
                                                                        let path = "/Uploads/FFCA_LinksUploads/2023/";
                                                                        ImagePdfBucket(e, AfflFfcaPhotoFormik, path, `tmcPhoto${index}`, filename, "image");
                                                                    }} />
                                                            </bie.Col>
                                                            <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} className='mb-2'>
                                                                {FfcaPhoto && FfcaPhoto[`tmc_photo_${index}`] && (
                                                                    <button type="button" onClick={() => { const photoPath = FfcaPhoto[`tmc_photo_${index}`]; viewImage(photoPath); }} className="btn btn-primary">
                                                                        <FaEye size={20} />
                                                                    </button>
                                                                )}
                                                            </bie.Col>
                                                        </bie.Row>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="pt-1 mb-3">
                                    <button type='submit' className='btn btn-success btn-sm float-end  mb-2'>Submit</button>
                                </div>
                            </Form>
                        </bie.Row>

                    </FormikProvider>
                </bie.Container>
            </bie.Container >
        </>
    )
}

